module.exports = __webpack_public_path__ + "img/stage-1.16e89dcc.png";